const style = {
  listSection__selectionButtonSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
};

export default style;
